import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import {IPaymentMethod} from 'modules/wineshops-list/models';

interface IProps {
    payments?: IPaymentMethod[];
}

export const WineShopPaymentMethods: FC<IProps> = ({payments}) => {
    return Boolean(payments?.length) ? (
        <Typography className={style.paymentNames} element={'div'} variant={'label-16-r'}>
            {payments?.map(({title: paymentName}) => paymentName).join(', ')}
        </Typography>
    ) : null;
};
